import React, { useContext, useEffect } from 'react';

import { track } from '../../../analytics/analytics';
import { EventIDs } from '../../../analytics/events';
import { INV_DNLD_SUCCESS } from '../../../constants/urls';
import { useGlobalState } from '../../context/qrState';
import { UserContext } from '../../context/userContext';
import {
  Container,
  Img,
  Text,
  Details,
  OkayBtn,
  SuccessContainer,
} from './styles';

const DownloadSuccess = () => {
  const { email } = useContext<Record<string, any>>(UserContext);
  const [
    showDownloadSuccessLayout,
    setShowDownloadSuccessLayout,
  ] = useGlobalState('DownloadSuccess');

  useEffect(() => {
    if (showDownloadSuccessLayout) {
      const payload = {
        email,
      };
      track(EventIDs.INVOICES_DOWNLOAD_SUCCESS, payload);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDownloadSuccessLayout]);

  const okayBtnClick = () => {
    setShowDownloadSuccessLayout(false);
    const payload = {
      email,
    };
    track(EventIDs.INVOICES_OKAY_CLICK, payload);
  };

  return (
    <>
      {showDownloadSuccessLayout && (
        <>
          <Container>
            <SuccessContainer>
              <Img src={INV_DNLD_SUCCESS} alt="" />
              <Text>Invoice successfully downloaded!</Text>
              <Details>
                <span>You can find your downloaded invoice in</span>
                <span>downloads</span>
              </Details>
              <OkayBtn onClick={okayBtnClick}>okay</OkayBtn>
            </SuccessContainer>
          </Container>
        </>
      )}
    </>
  );
};

export default DownloadSuccess;
